import {
  FEATURE_FLAGS_FAILURE,
  FEATURE_FLAGS_REQUESTED,
  FEATURE_FLAGS_SUCCESS,
  FeatureFlag,
  FeatureFlagsState
} from './featureFlagTypes';

export const initialState: FeatureFlagsState = {
  flags: {},
  loading: false,
  loaded: false,
  error: null
};

interface FeatureFlagAction {
  type: string;
  payload?: FeatureFlag[] | { error: string };
}

const toFlagsMap = (flags: FeatureFlag[]): Record<string, boolean> =>
  flags.reduce<Record<string, boolean>>((map, flag) => {
    map[flag.key] = flag.enabled;
    return map;
  }, {});

const featureFlagReducer = (
  state: FeatureFlagsState = initialState,
  action: FeatureFlagAction = { type: '' }
): FeatureFlagsState => {
  switch (action.type) {
    case FEATURE_FLAGS_REQUESTED:
      return { ...state, loading: true, error: null };
    case FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        flags: toFlagsMap((action.payload as FeatureFlag[]) ?? []),
        loading: false,
        loaded: true,
        error: null
      };
    case FEATURE_FLAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: (action.payload as { error: string })?.error ?? 'Unknown error'
      };
    default:
      return state;
  }
};

export default featureFlagReducer;
